/* Scoped to the independent EVO product section. No global storefront listeners. */
if (!customElements.get('aipi-evo-pdp')) {
  customElements.define('aipi-evo-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.galleryByFinish = JSON.parse(this.querySelector('[data-gallery-variants]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
      this.finish = this.querySelector('.ep-finishes input:checked')?.value || 'black';
      this.querySelector('.ep-finishes').disabled = false;
      this.view = this.galleryByFinish[this.finish] || this.querySelector('[data-gallery]')?.dataset.gallery;
      this.addEventListener('change', event => {
        if (event.target.matches('.ep-finishes input')) {
          this.finish = event.target.value;
          const variant = this.variants.find(item => item.option1.toLowerCase() === this.finish);
          if (variant && /\/products\//.test(location.pathname)) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url); }
          this.view = this.galleryByFinish[this.finish] || this.querySelector('[data-gallery]')?.dataset.gallery;
          this.querySelector('[data-finish-name]').textContent = this.finish === 'black' ? 'Black' : 'White';
          this.updateGallery(true);
          this.updateVariant();
        }
      }, options);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery]');
        if (thumb && this.contains(thumb)) { this.view = thumb.dataset.gallery; this.updateGallery(true); }
        const video = event.target.closest('[data-video]');
        if (video && this.contains(video)) this.playVideo(video);
      }, options);
      this.querySelector('.ep-product-form')?.addEventListener('submit', event => {
        const button = this.querySelector('[data-add-to-cart]');
        if (!button || button.disabled) event.preventDefault();
      }, options);
      window.addEventListener('aipi:evo-sale-state', () => this.updateVariant(), options);
      this.initGallery(options);
      this.updateGallery();
      this.updateVariant();
      this.initPackaging();
    }
    disconnectedCallback() { this.galleryCleanup?.(); this.packCleanup?.(); this.controller?.abort(); this.controller = null; }
    initPackaging() {
      const root = this.querySelector('[data-packaging]');
      if (!root) return;
      const track = root.querySelector('.ep-pack-track');
      const stage = root.querySelector('.ep-pack-stage');
      const board = root.querySelector('.ep-pack-parts');
      const parts = [...root.querySelectorAll('[data-pack-part]')];
      const preference = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this.controller.signal };
      let frame = 0, visible = false;
      const stop = () => { cancelAnimationFrame(frame); frame = 0; };
      const draw = () => {
        frame = 0;
        if (preference.matches || !visible) return;
        const mobile = stage.clientWidth < 600;
        const positions = mobile
          ? {cover:[100,75,150], device:[250,155,130], battery:[100,240,105], guide:[250,330,130], tray:[100,375,130]}
          : {cover:[310,160,350], device:[420,300,280], battery:[660,310,180], guide:[155,415,220], tray:[530,495,280]};
        const width = mobile ? 360 : 800, height = mobile ? 460 : 640;
        const scale = Math.min((stage.clientWidth - 32) / width, (stage.clientHeight - 60) / height, 1);
        const top = parseFloat(getComputedStyle(stage).top);
        const progress = Math.max(0, Math.min(1, (top - track.getBoundingClientRect().top) / Math.max(1, track.offsetHeight - stage.offsetHeight)));
        board.style.width = `${width}px`;
        board.style.height = `${height}px`;
        board.style.transform = `translate(-50%,-50%) scale(${scale})`;
        parts.forEach((part, index) => {
          const [x, y, size] = positions[part.dataset.packPart];
          let t = Math.max(0, Math.min(1, (progress - index * .07) / .65));
          t = t * t * (3 - 2 * t);
          const cover = index === 0;
          part.style.width = `${size}px`;
          part.style.transform = `translate(${width/2 + (x-width/2)*t}px,${height/2 + (y-height/2)*t}px) translate(-50%,-50%) scale(${cover ? 1.45 - .45*t : .65 + .35*t})`;
          part.style.opacity = cover ? '1' : String(t);
          part.style.zIndex = cover ? (progress < .15 ? '10' : '1') : String(6-index);
          part.querySelector('figcaption').style.opacity = String(Math.max(0, (t-.8)*5));
        });
        root.querySelector('.ep-pack-hint').style.opacity = String(1 - Math.min(1, progress * 5));
      };
      const schedule = () => { if (!frame && visible && !preference.matches) frame = requestAnimationFrame(draw); };
      const mode = () => { stop(); root.dataset.animated = String(!preference.matches); schedule(); };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) schedule(); else stop();
      }, {rootMargin:'200px'});
      observer.observe(track);
      const resize = new ResizeObserver(schedule);
      resize.observe(stage);
      window.addEventListener('scroll', schedule, {...options, passive:true});
      window.addEventListener('resize', schedule, {...options, passive:true});
      preference.addEventListener('change', mode, options);
      mode();
      this.packCleanup = () => { stop(); observer.disconnect(); resize.disconnect(); root.removeAttribute('data-animated'); };
    }
    initGallery(options) {
      const thumbs = [...this.querySelectorAll('[data-gallery]')];
      const step = delta => {
        const index = thumbs.findIndex(button => button.dataset.gallery === this.view);
        this.view = thumbs[(index + delta + thumbs.length) % thumbs.length].dataset.gallery;
        this.updateGallery(true);
      };
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => step(-1), options);
      this.querySelector('[data-gallery-next]').addEventListener('click', () => step(1), options);
      this.querySelector('.ep-thumbs').addEventListener('keydown', event => {
        const button = event.target.closest('[data-gallery]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.view = button.dataset.gallery;
        if (event.key === 'Home' || event.key === 'End') {
          this.view = thumbs[event.key === 'Home' ? 0 : thumbs.length - 1].dataset.gallery;
          this.updateGallery(true);
        } else step(event.key === 'ArrowLeft' ? -1 : 1);
        this.querySelector(`[data-gallery="${this.view}"]`).focus({preventScroll:true});
      }, options);
      let pointer;
      const gallery = this.querySelector('.ep-gallery');
      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch' || !event.target.closest('[data-gallery-panel]') || event.target.closest('button,a,video')) return;
        pointer = {x:event.clientX, y:event.clientY};
      }, options);
      gallery.addEventListener('pointerup', event => {
        if (!pointer) return;
        const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
        pointer = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
      }, options);
      gallery.addEventListener('pointercancel', () => { pointer = null; }, options);
      const dialog = this.querySelector('.ep-film-dialog');
      const film = dialog.querySelector('video');
      this.querySelectorAll('[data-film]').forEach(trigger => trigger.addEventListener('click', event => {
        const source = event.currentTarget;
        this.activeVideo?.frame.replaceWith(this.activeVideo.poster);
        this.activeVideo = null;
        dialog.querySelector('strong').textContent = source.dataset.filmTitle || 'A conversation from the EVO launch film';
        dialog.querySelector('[data-film-note]').textContent = source.dataset.filmNote || 'Custom build shown. No custom body is needed to talk through EVO.';
        film.src = source.dataset.film;
        dialog.showModal();
        film.play().catch(() => {});
      }, options));
      this.querySelector('[data-film-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, options);
      dialog.addEventListener('close', () => { film.pause(); film.removeAttribute('src'); film.load(); }, options);
      const buyButton = this.querySelector('[data-add-to-cart]');
      const bar = this.querySelector('[data-mobile-buybar]');
      const observer = new IntersectionObserver(entries => {
        bar.hidden = !(matchMedia('(max-width: 700px)').matches && entries[0].boundingClientRect.bottom < 60);
      }, {rootMargin:'-60px 0px 0px 0px', threshold:[0,1]});
      if (buyButton) observer.observe(buyButton);
      this.galleryCleanup = () => { observer.disconnect(); film.pause(); if(dialog.open) dialog.close(); };
    }
    updateGallery(interacted = false) {
      const thumbs = [...this.querySelectorAll('[data-gallery]')];
      this.querySelectorAll('[data-gallery-panel]').forEach(panel => {
        panel.hidden = panel.dataset.galleryPanel !== this.view;
        if (!panel.hidden) panel.querySelectorAll('img[data-src]').forEach(image => { image.src = image.dataset.src; image.removeAttribute('data-src'); });
      });
      thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallery === this.view)));
      const index = thumbs.findIndex(button => button.dataset.gallery === this.view);
      this.querySelector('[data-gallery-status]').textContent = `${index+1} / ${thumbs.length} · ${thumbs[index].dataset.label}`;
      if (interacted) {
        const strip = this.querySelector('.ep-thumbs');
        const thumb = thumbs[index];
        strip.scrollLeft = Math.max(0, thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth)/2);
      }
    }

    updateVariant() {
      const state = window.AipiEvoSale?.state();
      if (state?.product?.variants) this.variants = state.product.variants;
      const variant = this.variants.find(item => item.option1.toLowerCase() === this.finish);
      const input = this.querySelector('[data-variant-input]');
      if (input) input.value = variant?.id || '';
      const expectedPrice = state?.expectedPrice ?? Number(this.dataset.expectedPrice);
      const open = state?.open ?? Date.now() >= Date.parse('2026-10-16T00:00:00-04:00');
      const configured = this.dataset.ordersConfigured === 'true' && this.dataset.currency === 'USD';
      const button = this.querySelector('[data-add-to-cart]');
      if (button) {
        const priceMatches = variant?.price === expectedPrice;
        button.disabled = !open || !configured || !variant?.available || !priceMatches;
        button.textContent = !open ? 'Opens Oct 16, 12 AM ET' : !configured || !priceMatches ? 'Currently unavailable' : variant.available ? 'Add to cart' : 'Sold out';
      }
      const updates = this.querySelector('[data-ep-launch-updates]');
      if (updates) { updates.hidden = open; updates.style.display = open ? 'none' : ''; }
      const price = this.querySelector('[data-ep-price]');
      if (price) price.textContent = '$' + (expectedPrice / 100).toFixed(2);
      const comparePrice = this.querySelector('[data-ep-compare-price]');
      if (comparePrice) comparePrice.hidden = expectedPrice !== 4999;
      this.querySelector('[data-ep-sticky-price]').textContent = '$' + (expectedPrice / 100).toFixed(2);
      this.querySelector('[data-ep-sticky-finish]').textContent = this.finish === 'black' ? 'Black' : 'White';
      const label = this.querySelector('[data-ep-price-label]');
      if (label) label.textContent = 'USD · ' + (expectedPrice === 4999 ? 'early-bird price' : 'regular price');
      const offer = this.querySelector('.ep-offer');
      if (offer && expectedPrice !== 4999) offer.style.display = 'none';
    }
    playVideo(button) {
      const id = button.dataset.video;
      if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
      // Only one community video plays at a time; restore the previous poster.
      if (this.activeVideo) this.activeVideo.frame.replaceWith(this.activeVideo.poster);
      const frame = document.createElement('iframe');
      frame.className = 'ep-video-frame';
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      frame.title = button.getAttribute('aria-label').replace(/^Play /, '');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      button.replaceWith(frame);
      this.activeVideo = { frame, poster: button };
    }
  });
}



